import { useSubscriptionStore } from '@stores/subscription'

import { useSubscriptionRetryApi } from '@api/subscription/subscription-retry.hook'
import { useToast } from '@hooks/toast/index.hook'

import amplitudeConf from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

interface FailedPaymentRetryReturn {
  name: string
  btnText: string
  setSubmit: () => Promise<void>
}
export const useFailedPaymentRetry = (): FailedPaymentRetryReturn => {
  const subscriptionStore = useSubscriptionStore()
  const toast = useToast()

  const name = 'retry_payment'
  const btnText = 'Retry payment'

  const setSubmit = async (): Promise<void> => {
    const subscriptionId = subscriptionStore.paymentRetryData?.subscription?.id || null

    trackEvent(amplitudeConf.events.clickSubmitButton, {
      button_name: name,
      button_text: btnText,
      valid: !subscriptionId ? 'false' : 'true',
    })

    if (!subscriptionId) {
      toast.error({
        title: 'Invalid subscription ID',
        description: 'Invalid subscription ID',
      })
    } else {
      const retry = false
      subscriptionStore.setBannerPaymentRetry(retry)
      subscriptionStore.setRetryPaymentModal(retry)

      const processing = true
      subscriptionStore.setBannerPaymentRetryProcessing(processing)
      subscriptionStore.setModalRetryPaymentProcessing(processing)

      await useSubscriptionRetryApi({
        onError: (err: any) => {
          subscriptionStore.setRetryPaymentModal(true)

          const processing = false
          subscriptionStore.setBannerPaymentRetryProcessing(processing)
          subscriptionStore.setModalRetryPaymentProcessing(processing)

          toast.error({
            title: 'Unexpected error',
            description: err.response?.data?.message || err?.message || 'Unexpected error',
          })
        },
      })
    }
  }

  return {
    name,
    btnText,
    setSubmit,
  }
}
